import { render, staticRenderFns } from "./PracticeItem.vue?vue&type=template&id=107977e0&scoped=true&"
import script from "./PracticeItem.vue?vue&type=script&lang=js&"
export * from "./PracticeItem.vue?vue&type=script&lang=js&"
import style0 from "./PracticeItem.vue?vue&type=style&index=0&id=107977e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107977e0",
  null
  
)

export default component.exports